import React, { useState, useEffect } from "react";
import { Formik, Field, Form, ErrorMessage, useFormikContext } from "formik";
import * as Yup from "yup";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import api from "../Authentication/authService";
import { useDispatch, useSelector } from "react-redux";
import { LoginSucessfull } from "../../context/AuthenticationSlice";
import Cookies from "js-cookie";
import Swal from "sweetalert2";
import { PaymentStatus } from "../../context/PaymentStatusSlice";
import withReactContent from "sweetalert2-react-content";
import { CONFIG } from "../../config";
import Toast from "../../Toast/Toast";
import DetailsNavbar from "../DetailsNavbar/DetailsNavbar";
import Footer from "../Footer/Footer";
import Tooltip from "@mui/material/Tooltip";


// Moves focus to the first invalid field after an unsuccessful form submission.
function FocusFirstError() {
  const { errors, submitCount, isValidating } = useFormikContext();

  const lastFocusedSubmitCount = React.useRef(0);

  useEffect(() => {

    if (submitCount === 0 || isValidating) return;

    // Only move focus once for each form submission
    if (lastFocusedSubmitCount.current === submitCount) return;

    // Mark this submission as handled
    lastFocusedSubmitCount.current = submitCount;

    const fieldOrder = [
      "CredenceAccountNumber",
      "lastName",
      "ssn",
      "zip",
      "captcha",
    ];

    const firstInvalidField = fieldOrder.find((fieldName) =>
      Boolean(errors[fieldName])
    );

    if (firstInvalidField) {
      document.getElementById(firstInvalidField)?.focus();
    }

  }, [submitCount, isValidating, errors]);

  return null;
}

function Login() {

  const [toast, setToast] = useState(null);

  const { CredenceAccountNumber } = useSelector(
    (state) => state.Authentication
  );
  const MySwal = withReactContent(Swal);

  const [captcha, setCaptcha] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const CAPTCHA_LENGTH = 5;
const CAPTCHA_CHARACTERS = "ABCDEFGHJKLMNPQRSTUVWXYZ234679";
const captchaCanvasRef = React.useRef(null);

const generateCaptchaValue = () => {
  let value = "";

  for (let i = 0; i < CAPTCHA_LENGTH; i++) {
    const randomIndex = Math.floor(
      Math.random() * CAPTCHA_CHARACTERS.length
    );

    value += CAPTCHA_CHARACTERS[randomIndex];
  }

  return value;
};

const randomDarkColor = () => {
  const value = Math.floor(Math.random() * 100);

  return `rgb(${value}, ${value}, ${value})`;
};

const drawCaptcha = (captchaValue) => {
  const canvas = captchaCanvasRef.current;

  if (!canvas) return;

  const ctx = canvas.getContext("2d");

  const width = canvas.width;
  const height = canvas.height;

  // Clear canvas
  ctx.clearRect(0, 0, width, height);

  // Background
  ctx.fillStyle = "#ffffff";

  ctx.fillRect(0, 0, width, height);

  // Noise lines
  for (let i = 0; i < 12; i++) {
    ctx.strokeStyle = randomDarkColor();
    ctx.lineWidth = 1;

    ctx.beginPath();

    ctx.moveTo(
      Math.random() * width,
      Math.random() * height
    );

    ctx.lineTo(
      Math.random() * width,
      Math.random() * height
    );

    ctx.stroke();
  }

  // CAPTCHA characters
  const characterSpacing = 54;
  const startingX = 25;

  captchaValue.split("").forEach((character, index) => {
    const x = startingX + index * characterSpacing;

    const y = 64 + (Math.random() * 10 - 5);

    const rotation = Math.random() * 0.3 - 0.15;

    ctx.save();

    ctx.translate(x, y);
    ctx.rotate(rotation);

    ctx.font = "bold 42px Arial";
    ctx.fillStyle = "#111827";

    ctx.fillText(character, 0, 0);

    ctx.restore();
  });

  // Random dots
  for (let i = 0; i < 35; i++) {
    ctx.fillStyle = randomDarkColor();

    ctx.beginPath();

    ctx.arc(
      Math.random() * width,
      Math.random() * height,
      1.5,
      0,
      Math.PI * 2
    );

    ctx.fill();
  }
};

const generateCaptcha = () => {
  const newCaptcha = generateCaptchaValue();

  setCaptcha(newCaptcha);

  return newCaptcha;
};
  useEffect(() => {
    generateCaptcha();
    Cookies.remove("Token");
    Cookies.remove("RefreshToken");
  }, []);

  useEffect(() => {
    if (captcha) {
      drawCaptcha(captcha);
    }
  }, [captcha]);

  const speakCaptcha = () => {
    if (!captcha) return;
  
    window.speechSynthesis.cancel();
  
    const spokenCharacters = captcha
      .split("")
      .map((character) => {
        if (character === "2") return "two";
        if (character === "3") return "three";
        if (character === "4") return "four";
        if (character === "6") return "six";
        if (character === "7") return "seven";
        if (character === "9") return "nine";
  
        return character;
      })
      .join(", ");
  
    const message =
      `CAPTCHA challenge. Enter the following characters: ${spokenCharacters}`;
  
    const speech = new SpeechSynthesisUtterance(message);
  
    speech.rate = 0.8;
    speech.pitch = 1;
    speech.volume = 1;
  
    window.speechSynthesis.speak(speech);
  };

  const apiUrl = CONFIG.REACT_APP_API_BASE_URL;;

  const handleLogin = async (values, { resetForm }) => {
   
  const enteredCaptcha = values.captcha
  .trim()
  .toUpperCase();

if (enteredCaptcha !== captcha) {
  setToast({
    type: "error",
    message: "Captcha is not correct.",
  });

  return;
}
    await api
      .post(`${apiUrl}/LoginAPI`, values)
      .then((response) => {
        if (response.status === 200) {
          const { token, refreshToken } = response.data;

          dispatch(
            LoginSucessfull({
              CredenceAccountNumber: values.CredenceAccountNumber,
              LastName: values.LastName,
              SSN: values.ssn,
            })
          );

          dispatch(
            PaymentStatus({
              paymentPlanStatus: "",
              paymentStatus: "",
            })
          );

          // Cookies.remove("Token");
          // Cookies.remove("RefreshToken");
         
          Cookies.set("Token", token);
          Cookies.set("RefreshToken", refreshToken);

          resetForm();

          if (token != null) {
            navigate("/Profile");
            window.scrollTo({ top: 0, behavior: "smooth" });
          } else if (
            response.data.validationResult ==
            "Your account is no longer assigned to Credence Resource Management, LLC. Please contact the creditor."
          ) {
            setToast({
              type: "warning",
              message:
                "Your account is no longer assigned to Credence Resource Management, LLC, please contact the creditor.",
            });
          } else if (
            response.data.validationResult ==
            "Your account is no longer associated  to Credence Resource Management, LLC. Please call back on +1-855-880-4791 for assistance."
          ) {
            setToast({
              type: "warning",
              message:
                "Your account is no longer associated to Credence Resource Management, LLC. Please call back on +1-855-880-4791 for assistance.",
            });
          } else {
            setToast({
              type: "error",
              message:
                "Login failed. Please call back on +1-855-880-4791 for assistance.",
            });
          }
        } else {
          setToast({
            type: "error",
            message: "Something went wrong, please try again.",
          });
        }
      })
      .catch(() => {
        setToast({
          type: "error",
          message: "Something went wrong, please try again.",
        });
      });
  };

  const validationSchema = Yup.object().shape({
    CredenceAccountNumber: Yup.number()
      .typeError("Credence Account Number should be an integer")
      .positive("Credence Account Number should be a positive number")
      .integer("Credence Account Number should be an integer")
      .required("Credence Account Number is required")
      .max(
        99999999999999999999,
        "Credence Account Number should not be more than 20 digits"
      ),
    lastName: Yup.string()
      .required("Last Name is required")
      .max(50, "Last Name should not exceed 50 characters"),
    // .matches(/^[a-zA-Z0-9\s!@#$%^&*()\-_=+[\]{};:'",.<>/?\\|`~]+$/, 
    //   "Last Name contains invalid characters"),

    ssn: Yup.string().matches(/^\d{4}$/, "SSN must be exactly 4 digits"),
    zip: Yup.string().matches(
      /^\d{5}$/,
      "ZIP Code must be exactly 5 digits"
    ),
    captcha: Yup.string().required("Captcha is required"),
  });

  return (
    <>
      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast(null)}
        />
      )}
      <DetailsNavbar />
      <main className="container-fluid p-0">
        <section className="login-section">
          <div className="login-container">
            <div className="login-visual-content">
              <div className="login-img">
                <img src="./assets/images/modern-female-device-1.webp" width="auto" alt="" role="presentation" />
              </div>
            </div>
            <div className="form-section">
              <Formik
                initialValues={{
                  CredenceAccountNumber: "",
                  lastName: "",
                  zip: "",
                  ssn: "",
                  captcha: "",
                }}
                validationSchema={validationSchema}
                validateOnChange={true}
                validate={(values) => {
                  const errors = {};
                  if (!values.ssn && !values.zip) {
                    errors.ssn = "Either SSN or ZIP code is required";
                    //errors.zip = 'Either SSN or ZIP code is required';
                  }
                  // if (
                  //   values.captcha.trim().toUpperCase() !==
                  //   captcha.toUpperCase()
                  // ) {
                  //   errors.captcha = "Incorrect CAPTCHA.";
                  // }
                  return errors;
                }}
                onSubmit={handleLogin}
              >
                {({ values, errors, handleChange, handleBlur, isSubmitting }) => (
                  <Form>
                    <FocusFirstError />
                    <div className="card">
                      <div className="card-body px-5">
                        <div className="row">
                          <div className="col-md-12 text-center">
                            <h1 className="mb-4 lgn-text">
                              Log in to Your Account
                            </h1>
                          </div>
                          <div className="col-md-12">
                            <label
                              className="form-label"
                              htmlFor="CredenceAccountNumber"
                            >
                              Credence Account Number{" "}
                              <span className="text-danger" aria-hidden="true">*</span>
                              
                            </label>
                            <Tooltip
  title="This number can be found on Credence letters as the Credence Reference ID, Credence Reference, or Credence Master Reference, and in texts as the Credence account number."
  arrow
  placement="top"
  enterTouchDelay={0}
  leaveTouchDelay={3000}
  slotProps={{
    tooltip: {
      sx: {
        backgroundColor: "#212529",
        color: "#fff",
        padding: "8px 12px",
        borderRadius: "6px",
        fontSize: "var(--font-size-xxxsmall)",
      },
    },
    arrow: {
      sx: {
        color: "#212529",
      },
    },
  }}
>
  <span style={{ display: "inline-flex", marginLeft: "5px" }}>
    <button
      type="button"
      aria-label="Credence Account Number Help"
      aria-describedby="credence-account-number-help"
      style={{
        border: "none",
        background: "transparent",
        padding: 0,
        cursor: "pointer",
        color: "inherit",
      }}
    >
      <i
        className="bx bx-info-circle"
        aria-hidden="true"
      />
    </button>
  </span>
</Tooltip>

<span
  id="credence-account-number-help"
  className="visually-hidden"
>
  This number can be found on Credence letters as the
  Credence Reference ID, Credence Reference, or Credence
  Master Reference, and in texts as the Credence account number.
</span>
                            
                            <Field
                              className="form-control"
                              type="text"
                              name="CredenceAccountNumber"
                              id="CredenceAccountNumber"
                              placeholder="Enter Credence Account Number"
                              onChange={handleChange}
                              maxLength={20}
                              onKeyDown={(e) => {
                                if (
                                  [8, 9, 13, 27, 46, 37, 38, 39, 40].includes(
                                    e.keyCode
                                  ) ||
                                  (e.ctrlKey &&
                                    ["a", "c", "v", "x"].includes(
                                      e.key.toLowerCase()
                                    ))
                                ) {
                                  return;
                                }
                                if (!/^\d$/.test(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                              aria-required="true"
                              aria-describedby={
                                errors.CredenceAccountNumber
                                  ? "account-number-error"
                                  : undefined
                              }
                            />
                            <div className="Error-msg">
                              <ErrorMessage
                                id="account-number-error"
                                name="CredenceAccountNumber"
                                component="div"
                                className="text-danger"
                              />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <label className="form-label" htmlFor="lastName">
                              Last Name <span className="text-danger" aria-hidden="true">*</span>
                            </label>
                            <Field
                              className="form-control"
                              type="text"
                              name="lastName"
                              id="lastName"
                              placeholder="Enter Last Name"
                              onChange={handleChange}
                              maxLength={50}
                              aria-required="true"
                              aria-describedby={
                                errors.lastName ? "last-name-error" : undefined
                              }
                            />
                            <div className="Error-msg">
                              <ErrorMessage
                                id="last-name-error"
                                name="lastName"
                                component="div"
                                className="text-danger"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row align-items-center">
                        <span id="ssn-zip-hint" className="visually-hidden">Provide either SSN or Zip Code</span>
                          <div className="col-md-6">
                            <label className="form-label" htmlFor="ssn">
                              Last 4 digits of SSN<span class="text-danger" aria-hidden="true">*</span>
                            </label>
                            <Field
                              className="form-control"
                              type="text"
                              name="ssn"
                              id="ssn"
                              maxLength="4"
                              placeholder="Enter Last 4 digit of SSN"
                              aria-describedby={
                                errors.ssn
                                  ? "ssn-zip-hint ssn-last4-error"
                                  : "ssn-zip-hint"
                              }
                              onChange={handleChange}
                            />
                            <div className="Error-msg">
                              <ErrorMessage
                                id="ssn-last4-error" 
                                name="ssn"
                                component="div"
                                className="text-danger"
                              />
                            </div>
                          </div>
                          <div className="col-md-1 d-flex justify-content-center">
                            <span aria-hidden="true">OR</span>
                          </div>
                          <div className="col-md-5">
                            <label className="form-label" htmlFor="zip">
                              5 Digit Zip Code
                              <span class="text-danger" aria-hidden="true">*</span>
                            </label>
                            <Field
                              className="form-control"
                              type="text"
                              name="zip"
                              id="zip"
                              maxLength="5"

                              placeholder="Enter Zip Code"
                              onChange={handleChange}
                              aria-required="true"
                              aria-describedby={
                                errors.zip
                                  ? "ssn-zip-hint zip-code-error"
                                  : "ssn-zip-hint"
                              }
                            />
                            <div className="Error-msg">

                              <ErrorMessage
                                id="zip-code-error"
                                name="zip"
                                component="div"
                                className="text-danger"
                              />
                            </div>
                          </div>
                        </div>

                        {/* <div className="error-container">
                          
                          </div> */}
                        <div className="row">

{/* CAPTCHA Canvas */}
<div className="col-md-7 mb-3">

  <fieldset className="captcha-container">

 

    <div className="captcha-image-container">
    <legend className="form-label">Captcha Verification</legend>
      {/* <label className="form-label">
        Captcha Verification
      </label> */}

      <div className="captcha-image-wrapper">

        <canvas
          ref={captchaCanvasRef}
          className="captcha-canvas"
          width="320"
          height="100"
          role="img"
          aria-label="CAPTCHA challenge. Use the Listen to CAPTCHA button to hear the characters."
        />

      </div>

    </div>

    <div
      className="captcha-actions"
      aria-label="CAPTCHA options"
    >

      

      {/* Refresh */}
      <button
        className="btn btn-outline-secondary d-flex align-items-center captcha-btn"
        type="button"
        onClick={generateCaptcha}
        title="Get a new CAPTCHA"
        aria-label="Get a new CAPTCHA"
      >
        <i
          className="bx bx-revision"
          aria-hidden="true"
        />
      </button>

      {/* Listen */}
      <button
        className="btn btn-outline-secondary d-flex align-items-center captcha-btn"
        type="button"
        onClick={speakCaptcha}
        title="Listen to CAPTCHA"
        aria-label="Listen to CAPTCHA"
      >
        <i
          className="bx bx-volume-full"
          aria-hidden="true"
        />
      </button>

    </div>

  </fieldset>

</div>


{/* CAPTCHA Input */}
<div className="col-md-5 mb-3">

  <label
    className="form-label"
    htmlFor="captcha"
  >
    Enter Captcha{" "}
    <span className="text-danger">*</span>
  </label>

  <Field
    className="form-control"
    id="captcha"
    type="text"
    name="captcha"
    placeholder="Enter Captcha"
    value={values.captcha}
    onChange={(e) => {
      e.target.value = e.target.value.toUpperCase();
      handleChange(e);
    }}
    onBlur={handleBlur}
    onPaste={(e) => {
      e.preventDefault();
    }}
    aria-required="true"
    aria-describedby={errors.captcha ? "captcha-error" : undefined}
  />

  <div className="Error-msg">
    <ErrorMessage
      id="captcha-error"
      name="captcha"
      component="div"
      className="text-danger"
    />
  </div>

</div>

</div>
                        <div className="row">
                          <div className="col-md-12 text-center mb-3 mt-3">
                            <button
                              type="submit"
                              className="btn btn-primary"
                              disabled={isSubmitting}
                            >
                              {isSubmitting ? "Submitting..." : "SUBMIT"}
                            </button>
                          </div>

                          <div className="col-md-12 ">
                            <div className="payment-methods justify-content-center" role="list" aria-label="Accepted payment methods">
                              <div className="d-flex align-items-center justify-content-center">
                                <div className="method-chip" role="listitem" aria-label="">
                                  <img src="/assets/images/payment-method/visa.webp" alt="Pay with Visa" />
                                </div>
                              </div>
                              <div className="d-flex align-items-center justify-content-center">
                                <div className="method-chip" role="listitem" aria-label="">
                                  <img src="/assets/images/payment-method/card.webp" alt="Pay with Mastercard" />
                                </div>
                              </div>
                              <div className="d-flex align-items-center justify-content-center">
                                <div className="method-chip" role="listitem" aria-label="">
                                  <img src="/assets/images/payment-method/google-pay.webp" alt="Pay with Google Pay" />
                                </div>
                              </div>
                              <div className="d-flex align-items-center justify-content-center">
                                <div className="method-chip" role="listitem" aria-label="">
                                  <img src="/assets/images/payment-method/apple-pay.webp" alt="Pay with Apple Pay" />
                                </div>
                              </div>
                              <div className="d-flex align-items-center justify-content-center">
                                <div className="method-chip" role="listitem" aria-label="">
                                  <img src="/assets/images/payment-method/discover.webp" alt="Pay with Discover" />
                                </div>
                              </div>
                            </div>
                          </div>
                          

                        </div>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </section>




      </main>
      <Footer />

    </>

  );
}

export default Login;
